module.exports = __webpack_public_path__ + "static/media/AS.1365e350.svg";